import {
  createDeployment as publicCreateDeployment,
  getDeployment as publicGetDeployment,
  publishDeployment as publicPublishDeployment,
  publishRcDeployment as publicPublishRcDeployment,
  listDeployments as publicListDeployments,
  queryDeployments as publicQueryDeployments,
  reportDeploymentPipelineResult as publicReportDeploymentPipelineResult,
  getDeploymentPipelineDescription as publicGetDeploymentPipelineDescription,
  updateExtendedFields as publicUpdateExtendedFields,
} from './document-management-editor-deployments-v1-deployment-deployments.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const createDeployment: MaybeContext<
  BuildRESTFunction<typeof publicCreateDeployment> &
    typeof publicCreateDeployment
> = /*#__PURE__*/ createRESTModule(publicCreateDeployment);
export const getDeployment: MaybeContext<
  BuildRESTFunction<typeof publicGetDeployment> & typeof publicGetDeployment
> = /*#__PURE__*/ createRESTModule(publicGetDeployment);
export const publishDeployment: MaybeContext<
  BuildRESTFunction<typeof publicPublishDeployment> &
    typeof publicPublishDeployment
> = /*#__PURE__*/ createRESTModule(publicPublishDeployment);
export const publishRcDeployment: MaybeContext<
  BuildRESTFunction<typeof publicPublishRcDeployment> &
    typeof publicPublishRcDeployment
> = /*#__PURE__*/ createRESTModule(publicPublishRcDeployment);
export const listDeployments: MaybeContext<
  BuildRESTFunction<typeof publicListDeployments> & typeof publicListDeployments
> = /*#__PURE__*/ createRESTModule(publicListDeployments);
export const queryDeployments: MaybeContext<
  BuildRESTFunction<typeof publicQueryDeployments> &
    typeof publicQueryDeployments
> = /*#__PURE__*/ createRESTModule(publicQueryDeployments);
export const reportDeploymentPipelineResult: MaybeContext<
  BuildRESTFunction<typeof publicReportDeploymentPipelineResult> &
    typeof publicReportDeploymentPipelineResult
> = /*#__PURE__*/ createRESTModule(publicReportDeploymentPipelineResult);
export const getDeploymentPipelineDescription: MaybeContext<
  BuildRESTFunction<typeof publicGetDeploymentPipelineDescription> &
    typeof publicGetDeploymentPipelineDescription
> = /*#__PURE__*/ createRESTModule(publicGetDeploymentPipelineDescription);
export const updateExtendedFields: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExtendedFields> &
    typeof publicUpdateExtendedFields
> = /*#__PURE__*/ createRESTModule(publicUpdateExtendedFields);

export {
  DeploymentType,
  PipelineStatus,
  TaskStatus,
  DeploymentPipelinesStatus,
  RCLabel,
  PublishType,
  SortOrder,
  WebhookIdentityType,
} from './document-management-editor-deployments-v1-deployment-deployments.universal.js';
export {
  Deployment,
  DeploymentDescriptionOneOf,
  DeploymentCreationPublishTypeOneOf,
  EditorRevision,
  PipelineResult,
  TaskResult,
  EditorSession,
  ExtendedFields,
  CreationPublishTypeNone,
  CreationPublishTypeSite,
  CreationPublishTypeRC,
  DeploymentPipelineUpdatedMessage,
  CreateDeploymentRequest,
  CreateDeploymentRequestBasedOnOneOf,
  CreateDeploymentRequestPublishMethodOneOf,
  DeploymentAttribute,
  DeploymentAttributeAttributeOneOf,
  GridAppIdAttribute,
  SessionInfo,
  LatestFromBranch,
  PublishSiteRCMethod,
  CreateDeploymentResponse,
  GetDeploymentRequest,
  GetDeploymentResponse,
  PublishDeploymentRequest,
  PublishDeploymentResponse,
  PublishRCDeploymentRequest,
  PublishRCDeploymentResponse,
  ListDeploymentsRequest,
  ListDeploymentsResponse,
  QueryDeploymentsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryDeploymentsResponse,
  CursorPagingMetadata,
  Cursors,
  ReportDeploymentPipelineResultRequest,
  ReportDeploymentPipelineResultResponse,
  GetDeploymentPipelineDescriptionRequest,
  GetDeploymentPipelineDescriptionResponse,
  PipelineDescription,
  TaskDescription,
  Empty,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  CreateDeploymentOptions,
  CreateDeploymentOptionsBasedOnOneOf,
  CreateDeploymentOptionsPublishMethodOneOf,
  PublishDeploymentOptions,
  PublishRcDeploymentOptions,
  DeploymentsQueryResult,
  DeploymentsQueryBuilder,
  ReportDeploymentPipelineResultOptions,
  UpdateExtendedFieldsOptions,
} from './document-management-editor-deployments-v1-deployment-deployments.universal.js';
export {
  DeploymentTypeWithLiterals,
  PipelineStatusWithLiterals,
  TaskStatusWithLiterals,
  DeploymentPipelinesStatusWithLiterals,
  RCLabelWithLiterals,
  PublishTypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateDeploymentApplicationErrors,
  PublishDeploymentApplicationErrors,
  PublishRcDeploymentApplicationErrors,
  ReportDeploymentPipelineResultApplicationErrors,
  GetDeploymentPipelineDescriptionApplicationErrors,
} from './document-management-editor-deployments-v1-deployment-deployments.universal.js';
